import type {CouponStatusValue} from './types';
import type {ChipColor} from '@ds/types';

export const COUPON_ROUTES = {
  list: '/services/promotion-center/coupon/list',
  add: '/services/promotion-center/coupon/add',
  details: '/services/promotion-center/coupon/details/:couponId',
  paymentSuccess: '/services/promotion-center/coupon/payment/success'
} as const;

export const COUPON_STATUS_CONFIG: Record<CouponStatusValue, {label: string; color: ChipColor}> = {
  draft: {label: 'در انتظار اجرا', color: 'info'},
  active: {label: 'در حال اجرا', color: 'success'},
  completed: {label: 'پایان یافته', color: 'default'}
};
